import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          tracker_settings: {
            tabs: {
              trackers: {
                fixed_tracker_payments: {
                  change_fixed_payments_history: {
                    header: 'HEADER',
                    close: 'CLOSE',
                  },
                },
              },
            },
          },
        },
      },
    },
  }));
}
